module.exports = __webpack_public_path__ + "static/media/ks_door_highlight.17b6d00e.svg";